export default {
    common: {
        title: 'Content AI',
        socialPlanner: 'Sociale Planner',
        blog: 'Blog',
        funnel: 'Funnel',
        website: 'Website',
        mediaLibrary: 'Mediabibliotheek',
        email: 'E-Mail',
        words: 'Woorden',
        variations: 'Variaties',
        thisIsPaidService: 'Deze functie is een betaalde service en er zullen kosten in rekening gebracht worden op basis van uw gebruik',
        all: 'Todos',
    },
};
